export default __webpack_public_path__ + "static/media/Sarkar.af83439c.png";